import React, { useCallback, useEffect, useState } from 'react';

import InputSearch from '../../../../../atoms/search';
import Dialog from '../../../../../blocks/dialog';
import RecursionList from '../recursionList';

import { usePostReferenceWorkplace } from './hooks';

export default function Measures(props) {
  const [search, setSearch] = useState('');
  const [expandedKeys, setExpandedKeys] = useState([]);
  const { formik, currentMeasures, show, onShow } = props;
  const { referenceWorkPlace } = usePostReferenceWorkplace();

  const handleChangeSearch = (event) => {
    setSearch(event.target.value);
  };

  useEffect(() => {
    if (!show) {
      setSearch('');
    }
  }, [show]);

  const onClose = useCallback(() => {
    onShow.off();
    setExpandedKeys([]);
  }, []);

  return (
    <Dialog
      isRender={show}
      isClose={true}
      centered={false}
      onClose={onClose}
      title={'МЕРА'}
      settings={{
        title: {
          size: 14,
          fWeight: 600,
          lHeight: 17,
          align: 'left',
          margin: '-2px -20px 20px',
        },
        close: {
          height: 28,
          width: 28,
          right: '8px',
          top: '8px',
        },
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', rowGap: '12px' }}>
        <InputSearch width={'225px'} placeholder={'Поиск'} onChange={handleChangeSearch} />
        <RecursionList
          fieldValue="data.danger"
          search={search}
          formik={formik}
          arr={referenceWorkPlace}
          originalArr={referenceWorkPlace}
          onShow={onShow}
          currentMeasures={currentMeasures}
          expandedKeys={expandedKeys}
          setExpandedKeys={setExpandedKeys}
        />
      </div>
    </Dialog>
  );
}
